export default {
  title: "Reservas",
  descriptionSeller: "Gestione todas las reservas de sus actividades",
  descriptionHost: "Gestione las reservas de sus actividades",
  descriptionAdmin:
    "Vea las reservas y conversaciones de handshake de este vendedor",
  adminScopeTitle: "Primero elige un vendedor",
  adminScopeAction: "Ir a usuarios",
  adminScopeRequired:
    "Abra el detalle de un vendedor y use Ver reservas para ver sus reservas.",
  backToPartner: "Volver al vendedor",
  descriptionCustomer: "Vea sus reservas y suba tickets",
  sellerIdMissing: "No se encontró el ID de usuario del vendedor",
  errorLoad: "Error al cargar las reservas",
  viewSelectorLabel: "Vista",
  viewList: "Lista",
  viewCalendar: "Calendario",
  calendar: {
    previousWeek: "Semana anterior",
    nextWeek: "Semana siguiente",
    today: "Hoy",
    todayBadge: "Hoy",
    openDay: "Ver {{count}} citas el {{date}}",
    emptyDay: "Sin citas",
    emptyDayDescription: "No hay reservas programadas para este día.",
    dayStripEmpty: "—",
    dayStripSummary: "{{bookings}} res · {{covers}} pers",
    daySummaryWithCovers_one:
      "{{count}} reserva · {{covers}} personas en total",
    daySummaryWithCovers_other:
      "{{count}} reservas · {{covers}} personas en total",
  },
  cardTitle: "Reservas",
  needsAttention: {
    title: "Requieren atención",
    subtitle_one: "{{count}} reserva requiere su atención",
    subtitle_other: "{{count}} reservas requieren su atención",
    allClearTitle: "Todo en orden",
    allClearSubtitle: "Nada requiere atención ahora",
    seeAllBookings: "Ver todas las reservas",
    showAll: "Ver todas ({{count}})",
    showAllTitle: "Reservas que requieren atención",
  },
  stats: {
    tile: {
      confirmation: "Por confirmar",
      receipts: "Tickets por subir",
      guests: "Comensales hoy",
      completion: "Visitas por completar",
    },
  },
  activityFilter: {
    label: "Actividad",
    allActivities: "Todas las actividades",
    optionWithCount: "{{name}} ({{count}})",
  },
  statusFilter: {
    label: "Estado",
    any: "Todos los estados",
    optionWithCount: "{{name}} ({{count}})",
  },
  actionFilters: {
    label: "Filtrar por acción",
    all: "Todas las acciones",
    confirmation: "Pendientes de confirmación",
    receipt: "Ticket pendiente",
    completion: "Visita sin completar",
  },
  manageModal: {
    emptyTitle: "Nada pendiente",
    emptyDescription:
      "Todas las reservas están al día — no hay acciones requeridas.",
    completeConfirmTitle: "¿Marcar visita completada?",
    completeConfirmMessage:
      "Esto marcará la reserva como completada después de la visita.",
  },
  partyItems: {
    andMore_one: "+{{count}} más",
    andMore_other: "+{{count}} más",
  },
  list: {
    undatedSection: "Sin fecha de visita",
  },
  bookingCount_one: "{{count}} reserva",
  bookingCount_other: "{{count}} reservas",
  loading: "Cargando reservas...",
  emptyTitle: "Aún no hay reservas",
  emptyDescription:
    "Las reservas de clientes aparecerán aquí cuando reciba la primera",
  emptyFilteredTitle: "Ninguna reserva coincide con estos filtros",
  emptyFilteredDescription:
    "Prueba otro estado o actividad, o limpia los filtros para ver más.",
  unknownActivity: "Actividad desconocida",
  guest_one: "{{count}} persona",
  guest_other: "{{count}} personas",
  kioskBookingTitle: "Tablet usada para esta reserva",
  receiptUploadErrorTitle: "Error al subir el ticket",
  receiptUploadErrorMessage:
    "Se produjo un error al subir o analizar el ticket. Inténtelo de nuevo.",
  receiptConfirmErrorTitle: "Error al confirmar el ticket",
  receiptConfirmErrorMessage:
    "Se produjo un error al confirmar el ticket. Inténtelo de nuevo.",
  toastReceiptAlready: "El ticket ya está registrado para esta reserva.",
  toastPointsAwarded: "¡Ticket confirmado! +{{points}} puntos de fidelidad",
  toastPartnerUploaded: "Ticket subido correctamente. Total: {{total}}",
  receiptOcrUnreadableTitle: "Ticket ilegible",
  receiptOcrUnreadableFallback:
    "No se pudo leer el total del ticket. Vuelva a hacer la foto con más claridad.",
  receiptManualRequiredTitle: "Total manual requerido",
  receiptManualCta: "Introducir total",
  receiptManualRequiredMessage:
    "Se agotaron los intentos de validación del ticket. Introduce el importe total manualmente.",
  toastPartnerManualAmount: "Total manual del ticket guardado: {{total}}",
  alertGotIt: "Entendido",
  emptyDescriptionCustomer:
    "Sus reservas aparecerán aquí. Suba los tickets de las visitas completadas para ganar puntos.",
  status: {
    CREATED: "Pendiente de pago",
    PENDING_HANDSHAKE: "Handshake pendiente",
    ACCEPTED: "Aceptada",
    REJECTED: "Rechazada",
    COMPLETED: "Completada",
    CANCELED: "Cancelada",
    ABANDONED: "Caducada",
    unknown: "Estado desconocido",
  },
  partnerStatus: {
    pending: "Pendiente",
    confirmed: "Confirmada",
  },
  handshake: {
    messageCount_one: "{{count}} mensaje",
    messageCount_other: "{{count}} mensajes",
    loading: "Cargando conversación...",
    loadError: "No se pudo cargar la conversación de handshake",
    notFound: "Conversación de handshake no encontrada",
  },
  detail: {
    loading: "Cargando reserva...",
    loadError: "No se pudo cargar esta reserva",
    notFound: "Reserva no encontrada",
    backToList: "Volver a reservas",
    orderInfo: "Detalles del pedido",
    bookingSummary: "Reserva",
    requestedVisit: "Fecha solicitada",
    bookingType: "Tipo de reserva",
    bookingTypes: {
      restaurant: "Reservas de restaurante",
      service: "Reservas de servicio",
    },
    handshakeActions: "Acciones",
    chatSectionTitle: "Chat de handshake",
    chatChannelCustomer: "{{channel}} — {{name}}",
    chatClosedBadge: "Cerrada",
    moreActions: "Más acciones",
    supportHelpAction: "Abrir ticket de soporte",
    supportTicketSubject: "Reserva {{id}}",
    completeSectionTitle: "Completar visita",
    completeSectionDescription:
      "Marca esta reserva como completada una vez realizada la visita.",
    completeSectionAction: "Marcar completada",
    receiptSectionTitle: "Subir ticket",
    receiptSectionDescription:
      "Sube una foto del ticket para completar esta reserva y calcular la comisión.",
    receiptManualSectionTitle: "Introducir total del ticket",
    receiptManualSectionDescription:
      "Se han agotado los intentos de validación. Introduce el total manualmente para completar esta reserva.",
    cancelBookingBusy: "Cancelando reserva...",
    cancelBookingSuccess: "Reserva cancelada",
    cancelBookingError: "No se pudo cancelar esta reserva",
    cancelBookingPastVisitError:
      "No se puede cancelar una reserva después de la fecha de la visita",
    cancelBookingConfirmTitle: "¿Cancelar esta reserva?",
    cancelBookingConfirmMessage:
      "El cliente será reembolsado cuando corresponda. Esta acción no se puede deshacer.",
        cancelBookingConfirmMessageAdmin:
      "Cancel booking for {{name}} ({{amount}})? The refund starts automatically and cannot be undone.",
cancelBookingConfirmAction: "Cancelar reserva",
    statusInsight: {
      abandonedTitle: "Pago caducado",
      abandonedDescription:
        "El cliente no completó el pago a tiempo. No es una cancelación: la reserva nunca se confirmó.",
    },
    cancellationSource: {
      label: "Cancelada por",
      customer: "Cliente",
      partner: "Partner",
      system: "Sistema",
    },
    markComplete: "Marcar visita completada",
    markCompleteBusy: "Marcando como completada...",
    markCompleteSuccess: "Visita marcada como completada",
    markCompleteError: "No se pudo marcar la reserva como completada",
    chatViaChannel: "Chat por {{channel}}",
    receipt: "Ticket",
    noHandshake: "No hay conversación handshake para esta reserva",
    bookingId: "ID de reserva",
    services: "Servicios",
    visitDate: "Fecha de visita",
    visitTime: "Hora de visita",
    partySize: "Comensales / cantidad",
    customerName: "Cliente",
    email: "Correo",
    phone: "Teléfono",
    kiosk: "Tablet / dispositivo",
    generatingDevice: "Dispositivo generador",
    hostingStructure: "Estructura anfitriona",
    unnamedDevice: "Dispositivo sin nombre",
    total: "Total",
    amountPaid: "Importe pagado",
    listPrice: "Precio de lista",
    sellerDiscount: "Descuento del partner",
    sellerDiscountBadge: "Descuento partner",
    sellerDiscountNote:
      "Este descuento lo fijaste tú — tu pago se calcula sobre el precio del servicio tras esta rebaja.",
    servicePrice: "Precio del servicio",
    flitripDiscount: "Descuento Flitrip",
    flitripDiscountBadge: "Descuento Flitrip",
    flitripDiscountNote:
      "Tu pago sigue calculándose sobre el precio del servicio — Flitrip asume este descuento.",
    pointsDiscount: "Descuento por puntos",
    customerPaid: "Pagado por el cliente",
    createdAt: "Reservado el",
    customerNotes: "Notas del cliente",
    sellerNotes: "Notas del vendedor",
  },
  adminDetail: {
    tabs: {
      label: "Secciones del detalle de la reserva",
      overview: "Resumen",
    },
    ids: {
      title: "Referencias técnicas",
      hint: "IDs copiables para soporte y desarrolladores",
      handshakeSession: "Sesión de handshake",
      externalPayment: "Pago externo",
    },
    localTime: "({{time}} hora local)",
    sections: {
      parties: "Partes implicadas",
      customer: "Cliente",
      booking: "Reserva",
      payment: "Pago",
      receipt: "Ticket",
      chat: "Chat handshake",
    },
    timeline: {
      steps: {
        CREATED: "Creada",
        PENDING_HANDSHAKE: "Esperando handshake",
        ACCEPTED: "Aceptada",
        COMPLETED: "Completada",
        REJECTED: "Rechazada",
        CANCELED: "Cancelada",
        ABANDONED: "Caducada",
      },
    },
    phone: {
      reveal: "Mostrar",
      hide: "Ocultar",
      confirmTitle: "¿Mostrar el teléfono del cliente?",
      confirmMessage:
        "El acceso al teléfono del cliente queda registrado. Muéstralo solo si necesitas contactar al cliente por soporte.",
      confirmAction: "Mostrar teléfono",
      revealError: "No se pudo mostrar el teléfono",
    },
    partner: {
      activity: "Actividad",
      name: "Vendedor",
    },
    payment: {
      none: "No hay pago externo vinculado a esta reserva",
      noAccess: "No tienes permiso para ver pagos externos",
      models: {
        UPFRONT: "Por adelantado",
        RECEIPT_BASED: "Basado en ticket",
      },
      amount: "Importe del pago",
      providerId: "ID de pago del proveedor",
      viewPayment: "Ver en pagos",
      sellerDiscountNote:
        "Rebaja a cargo del partner — el pago del partner se calcula sobre el precio del servicio tras este descuento.",
      flitripDiscountNote:
        "Promo a cargo de la plataforma — el pago del partner sigue calculándose sobre el precio del servicio; Flitrip asume este descuento.",
    },
    economicEvents: {
      title: "Eventos económicos",
      none: "Aún no hay eventos económicos vinculados",
      noAccess: "No tienes permiso para ver eventos económicos",
      viewEvent: "Ver evento",
    },
    commissions: {
      activityShort: "Actividad",
      houseShort: "Alojamiento",
    },
    structure: {
      none: "No hay estructura anfitriona vinculada",
      host: "Anfitrión",
    },
    language: "Idioma",
    lineItems: {
      qtyUnit: "{{qty}} × {{unit}}",
    },
    receipt: {
      noneYet: "Aún no hay ticket del partner registrado",
      manualRequired: "Se requiere el importe del ticket manualmente",
      auditTitle: "Historial de subidas del ticket",
      auditEmpty: "Aún no hay subidas de ticket",
      viewUpload: "Ver imagen del ticket",
      viewUploadError: "No se pudo abrir la imagen del ticket",
      manualRegistered: "Importe manual registrado",
      amountSource: {
        OCR: "Registrado por OCR",
        MANUAL: "Registrado manualmente",
      },
      uploadStatus: {
        uploaded: "Subido",
        ocr_succeeded: "OCR correcto",
        ocr_failed: "OCR fallido",
        partner_rejected: "Rechazado por el partner",
        confirmed: "Confirmado",
      },
    },
    salesAgent: {
      none: "No hay agente comercial asignado a esta actividad",
      name: "Agente comercial",
    },
    chat: {
      readOnlyHint: "El chat es de solo lectura en esta página.",
    },
  },
  adminReceiptAdjust: {
    title: "Editar total del ticket",
    description:
      "Total registrado actual: {{current}}. Esto revertirá la asignación de comisión existente y creará una nueva.",
    amountLabel: "Nuevo total del ticket (EUR)",
    amountPlaceholder: "p. ej. 125,50",
    reasonLabel: "Motivo (opcional)",
    reasonPlaceholder: "¿Por qué se corrige este total?",
    submit: "Guardar nuevo total",
    action: "Editar total del ticket",
    success: "Total del ticket actualizado a {{total}}",
    error: "No se pudo actualizar el total del ticket",
    invalidAmount: "Introduce un importe válido mayor que cero",
    sameAmount: "El nuevo total debe ser distinto del total actual del ticket",
  },
  sellerNotesModal: {
    title: "Notas del vendedor",
    description:
      "Notas internas para tu equipo. Los clientes no pueden verlas.",
    placeholder: "Añade notas sobre esta reserva...",
    add: "Añadir notas",
    edit: "Editar notas",
    save: "Guardar notas",
    saveSuccess: "Notas del vendedor guardadas",
    saveError: "No se pudieron guardar las notas del vendedor",
    emptyDetail: "Aún no hay notas del vendedor.",
  },
} as const;
